import React from 'react';
import { _ProductDetail } from './Products';

interface Props {
  pDetailData: _ProductDetail;
}

type ChipType = 'for_whom' | 'category' | 'manufacturer' | 'difficulty' | 'material' | 'size' | 'format';

function chipTitle(type: ChipType): string {
  switch (type) {
    case 'for_whom':     return 'Pro koho';
    case 'category':     return 'Kategorie';
    case 'manufacturer': return 'Autor střihu';
    case 'difficulty':   return 'Obtížnost šití';
    case 'material':     return 'Doporučený materiál';
    case 'format':       return 'Formát střihu';
    default:             return '';
  }
}

const ProductDetailMeta: React.FC<Props> = ({ pDetailData }) => {
  const params = (pDetailData.parameters || {}) as any;
  const chips: { label: string; type: ChipType }[] = [];

  // format vynecháváme — má vlastní prominentní badge (ProductDetailFormat)
  (params.for_whom || []).forEach((p: any) => chips.push({ label: p.name, type: 'for_whom' }));
  (params.category || []).forEach((p: any) => chips.push({ label: p.name, type: 'category' }));
  (params.manufacturer || []).forEach((p: any) => chips.push({ label: p.name, type: 'manufacturer' }));
  (params.difficulty || []).forEach((p: any) => chips.push({ label: p.name, type: 'difficulty' }));
  (params.material || []).forEach((p: any) => chips.push({ label: p.name, type: 'material' }));

  if (chips.length === 0) return null;

  return (
    <div className="pd-meta">
      <div className="pd-meta__chips">
        {chips.map((c, i) => (
          <span
            key={`${c.type}-${i}`}
            className={`pd-chip pd-chip--${c.type}`}
            title={chipTitle(c.type)}
          >
            {c.label}
          </span>
        ))}
      </div>
    </div>
  );
};

export default ProductDetailMeta;
